export function getRandomUUID() {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }
  return (
    (new Date()).getTime().toString(36) +
    Math.random().toString(36).substring(2, 15)
  );
}
